import { render, staticRenderFns } from "./MsDynamics.vue?vue&type=template&id=3c319a84&"
import script from "./MsDynamics.vue?vue&type=script&lang=ts&"
export * from "./MsDynamics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports